var map = {
	"./alcohol/beer.svg": "26f3",
	"./alcohol/black-label.svg": "91c2",
	"./alcohol/champagne.svg": "fc02",
	"./alcohol/cocktail-long.svg": "dbc6",
	"./alcohol/cocktail.svg": "7dc2",
	"./alcohol/coconut-cocktail.svg": "d764",
	"./alcohol/jack.svg": "d866",
	"./alcohol/jagermeister.svg": "1563",
	"./alcohol/soda.svg": "a04c",
	"./alcohol/vodka.svg": "1fef",
	"./birthday/birthday-boy.svg": "5d5a",
	"./birthday/birthday-girl.svg": "1f24",
	"./birthday/cake.svg": "30f5",
	"./birthday/clown.svg": "701b",
	"./birthday/confetti.svg": "4151",
	"./birthday/disco-ball.svg": "7149",
	"./birthday/eye-mask.svg": "0f61",
	"./birthday/fireworks.svg": "68fb",
	"./birthday/present.svg": "bad4",
	"./birthday/punch.svg": "9be0",
	"./cats/beard-happy.svg": "5a50",
	"./cats/box.svg": "1072",
	"./cats/brown-happy.svg": "6b9a",
	"./cats/dotted.svg": "efd8",
	"./cats/ears.svg": "9e43",
	"./cats/laying.svg": "fd41",
	"./cats/love.svg": "98b4",
	"./cats/mug.svg": "7f48",
	"./cats/orange.svg": "3b5c",
	"./cats/white.svg": "4f06",
	"./dinosaurs/angel.svg": "fd63",
	"./dinosaurs/birthday.svg": "da3d",
	"./dinosaurs/chef.svg": "150e",
	"./dinosaurs/in-love.svg": "de1e",
	"./dinosaurs/music.svg": "3126",
	"./dinosaurs/santa-claus.svg": "893f",
	"./dinosaurs/sick.svg": "1625",
	"./dinosaurs/sleep.svg": "0519",
	"./dinosaurs/space.svg": "bfba",
	"./dinosaurs/thief.svg": "e573",
	"./dogs/beagle.svg": "0a10",
	"./dogs/corgi.svg": "e148",
	"./dogs/dalmatian.svg": "af00",
	"./dogs/french-bulldog.svg": "dccd",
	"./dogs/great-dane.svg": "44df",
	"./dogs/pointer.svg": "2630",
	"./dogs/poodle.svg": "90ba",
	"./dogs/samoyed.svg": "63bb",
	"./dogs/shiba-inu.svg": "d43f",
	"./dogs/siberian-husky.svg": "04af",
	"./drinks/coconut.svg": "bd79",
	"./drinks/coffee.svg": "8108",
	"./drinks/cola.svg": "b1b7",
	"./drinks/cosmopolitan.svg": "d13d",
	"./drinks/cream-soda.svg": "cbb1",
	"./drinks/infusion.svg": "5eec",
	"./drinks/latte-macchiato.svg": "02ba",
	"./drinks/milk-box.svg": "4a8d",
	"./drinks/orange-juice.svg": "50ac",
	"./drinks/wine.svg": "736e",
	"./fmcg/brush.svg": "164c",
	"./fmcg/cream.svg": "b394",
	"./fmcg/dryer.svg": "a23e",
	"./fmcg/eye-shadows.svg": "0635",
	"./fmcg/hand-mirror.svg": "2d5f",
	"./fmcg/lipstick.svg": "5222",
	"./fmcg/nail-polish.svg": "2e09",
	"./fmcg/shampoo.svg": "54a4",
	"./fmcg/soap.svg": "cf97",
	"./fmcg/sun-cream.svg": "3704",
	"./fruit/apple.svg": "5d8b",
	"./fruit/avocado.svg": "3a03",
	"./fruit/banana.svg": "f086",
	"./fruit/eggplant.svg": "dadb",
	"./fruit/lemon.svg": "4376",
	"./fruit/onion.svg": "7ae3",
	"./fruit/peach.svg": "891c",
	"./fruit/pomegranate.svg": "2c3e",
	"./fruit/potato.svg": "5938",
	"./fruit/watermelon.svg": "2cb0",
	"./kittens/coffee.svg": "465d",
	"./kittens/cook.svg": "0a70",
	"./kittens/crying.svg": "ccd5",
	"./kittens/gym.svg": "331d",
	"./kittens/music.svg": "4219",
	"./kittens/pencil.svg": "6e92",
	"./kittens/pirate.svg": "b760",
	"./kittens/scream.svg": "4d9b",
	"./kittens/sleep.svg": "dc47",
	"./kittens/what.svg": "0342",
	"./men/beer.svg": "fbcb",
	"./men/bicycle.svg": "6f43",
	"./men/book.svg": "ba46",
	"./men/football.svg": "b11a",
	"./men/games.svg": "4eef",
	"./men/joystick.svg": "8019",
	"./men/meditation.svg": "8f46",
	"./men/paintball.svg": "85d3",
	"./men/strong.svg": "f6f0",
	"./men/vodka.svg": "6ba1",
	"./men/wine.svg": "e189",
	"./mixed/apple.svg": "6232",
	"./mixed/avocado.svg": "b8d6",
	"./mixed/birthday-boy.svg": "d843",
	"./mixed/birthday-girl.svg": "e9b4",
	"./mixed/box.svg": "b292",
	"./mixed/cake.svg": "8aa4",
	"./mixed/cat-coffee.svg": "3560",
	"./mixed/coconut-cocktail.svg": "a048",
	"./mixed/coffee.svg": "3e4d",
	"./mixed/cola.svg": "380d",
	"./mixed/corgi.svg": "a598",
	"./mixed/games.svg": "c02c",
	"./mixed/green-tea.svg": "bf8a",
	"./mixed/jack.svg": "26d7",
	"./mixed/jagermeister.svg": "a609",
	"./mixed/joystick.svg": "0c88",
	"./mixed/lemon.svg": "cd04",
	"./mixed/mineral-water.svg": "ec98",
	"./mixed/onion.svg": "8d66",
	"./mixed/paintball.svg": "6cce",
	"./mixed/pointer.svg": "cd44",
	"./mixed/potato.svg": "3ac3",
	"./mixed/samoyed.svg": "03fa",
	"./mixed/shiba-inu.svg": "37b1",
	"./mixed/siberian-husky.svg": "6939",
	"./mixed/sick.svg": "a165",
	"./mixed/sleep.svg": "7004",
	"./mixed/space.svg": "6f99",
	"./mixed/sun-cream.svg": "2c28",
	"./mixed/tomato.svg": "e10e",
	"./mixed/unicorn.svg": "9127",
	"./mixed/watermelon.svg": "77f5",
	"./nature/avocado.svg": "d650",
	"./nature/flower.svg": "04dd",
	"./nature/green-tea.svg": "b936",
	"./nature/jojoba.svg": "ae5b",
	"./nature/lemon.svg": "a809",
	"./nature/mineral-water.svg": "5c83",
	"./nature/palm-oil.svg": "4d0a",
	"./nature/rose.svg": "e837",
	"./nature/tomato.svg": "d35b",
	"./sex/anal.svg": "7516",
	"./sex/choker.svg": "7dec",
	"./sex/dildo-rabbit.svg": "62fa",
	"./sex/dildo.svg": "08df",
	"./sex/flogger.svg": "1fe2",
	"./sex/handcuffs.svg": "7393",
	"./sex/lingerie.svg": "23a6",
	"./sex/mask.svg": "a672",
	"./sex/plug.svg": "d79f",
	"./sex/sex-shop.svg": "e395",
	"./unicorns/cake.svg": "b0dc",
	"./unicorns/cat.svg": "795f",
	"./unicorns/cupcake.svg": "3b3e",
	"./unicorns/rubber-ring.svg": "bc8f",
	"./unicorns/unicorn-1.svg": "f8b98",
	"./unicorns/unicorn-2.svg": "c4ea",
	"./unicorns/unicorn-3.svg": "700c",
	"./unicorns/unicorn-4.svg": "6b5b",
	"./unicorns/unicorn-5.svg": "d610",
	"./unicorns/unicorn.svg": "684d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "41da";